export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 64;
export const STRING_MIN_FIELD_LENGTH = 2;
export const STRING_FIELD_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 254; // RFC 5321 practical limit (64 local + 1 @ + 255 domain, but 254 is commonly used)
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).*$/;
export const USERNAME_PATTERN = /^$|^[a-zA-Z](?!.*[._]{2})[a-zA-Z0-9._]*$/;
export const STREET_FIELD_MAX_LENGTH = 100;
export const SANITIZE_SEARCH_TERM = /[^a-zA-Z0-9.@+!#$%&'*+\-\/=?^_`{|}~\s-]/g;
